// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useCallback, useState} from 'react';

import {UserAccountType} from '../../../../generated/graphql';
import {Analytics} from '../../../../services/analytics';
import {useViewer} from '../../../../state/viewer/hooks';
import {globalRegistryType} from '../../common/utils';
import {useUpsertRegistryProjectWithTypes} from '../../workflows/CreateRegistryDrawer/hooks';
import {useDeleteRegistryMembers} from './hooks';
import {isTeamRow, isUserRow, RegistryMemberRow} from './types';

export const RegistryMemberActions = ({
  member,
  registry,
}: {
  member: RegistryMemberRow;
  registry: globalRegistryType;
}) => {
  const viewer = useViewer();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {upsertRegistryProjectWithTypes, isLoading: isUpsertLoading} =
    useUpsertRegistryProjectWithTypes(registry.orgName, false);

  const {entityName, registryProjectName, registryName} = registry;
  const {removeRegistryMembers, isLoading: isDeleteLoading} =
    useDeleteRegistryMembers(entityName, registryProjectName);
  const onClickDelete = useCallback(
    async (memberToDelete: RegistryMemberRow) => {
      if (isUserRow(memberToDelete)) {
        await removeRegistryMembers(registry.id, [memberToDelete.id], []);
        Analytics.track('Registry interaction', {
          action: 'delete member',
          entityName,
          registryProjectName,
          registryName,
        });
      }
      if (isTeamRow(memberToDelete)) {
        await removeRegistryMembers(registry.id, [], [memberToDelete.id]);
        Analytics.track('Registry interaction', {
          action: 'delete team member',
          entityName,
          registryProjectName,
          registryName,
        });
      }
    },
    [
      entityName,
      registry.id,
      registryName,
      registryProjectName,
      removeRegistryMembers,
    ]
  );

  if (isUserRow(member) || isTeamRow(member)) {
    const isViewerOwner = member.id === registry.owner?.id;
    const isViewerCurrentMember = member.id === viewer?.id;
    return (
      <Tailwind style={{width: '100%', height: '100%'}}>
        <div className="registry-actions-container flex h-full items-center justify-end gap-8">
          <Button
            variant="ghost"
            icon="delete"
            onClick={() => onClickDelete(member)}
            disabled={isViewerOwner || isViewerCurrentMember || isDeleteLoading}
          />
          {isUserRow(member) && (
            <DropdownMenu.Root open={isMenuOpen} onOpenChange={setIsMenuOpen}>
              <DropdownMenu.Trigger asChild>
                <Button
                  size="medium"
                  variant="ghost"
                  icon="overflow-horizontal"
                  active={isMenuOpen}
                />
              </DropdownMenu.Trigger>
              <DropdownMenu.Content asChild align="end" alignOffset={-6}>
                <DropdownMenu.Item
                  onClick={async () => {
                    await upsertRegistryProjectWithTypes({
                      ...registry,
                      upsertAction: 'Edit',
                      inputArtifactTypes: [],
                      ownerId: member.id,
                    });
                  }}
                  disabled={
                    isViewerOwner ||
                    isViewerCurrentMember ||
                    member.accountType === UserAccountType.OrgService
                  }>
                  Make owner
                </DropdownMenu.Item>
              </DropdownMenu.Content>
            </DropdownMenu.Root>
          )}
        </div>
      </Tailwind>
    );
  }
  return null;
};
